import * as actions from './consts'
import difference from 'lodash/difference'
import { entitySetter } from '../utils'

const ACTION_HANDLERS = {
  [actions.SEED_CONTACTS]: (state, { contacts }) => entitySetter(state, contacts),
  [actions.CONTACTS_DELETE_SUCCESS]: (state, { loadedSelection }) => {
    const s = {...state};

    for (const id of loadedSelection) {
      delete s[id];
    }

    return s;
  },
  [actions.CONTACTS_SET_TAGS_SUCCESS]: (state, { ids, all, tags, loadedIds }) => {
    const s = {...state};
// TODO: тут, конечно, можно сэкономить очень много спичек, но нах
    const idsObj = ids.reduce( (obj, id ) => { obj[id] = true; return obj}, {});
    loadedIds.forEach(id => {
      if (!s[id]) return;

      if ( all != !idsObj[id] ) return;

      s[id] = {
        ...s[id],
        tags: (s[id].tags.concat(tags)),
      }
    })

    return s;
  },
  [actions.CONTACTS_DELETE_TAGS_SUCCESS]: (state, { ids, all, tags, loadedIds }) => {
    const s = {...state};

    const idsObj = ids.reduce( (obj, id ) => { obj[id] = true; return obj}, {});
    loadedIds.forEach(id => {
      if (!s[id]) return;

      if ( all != !idsObj[id] ) return;

      s[id] = {
        ...s[id],
        tags: difference(s[id].tags, tags),
      }
    })

    return s;
  },
  [actions.CONTACTS_SET_STAGE_SUCCESS]: (state, {id, stage}) => ({
    ...state,
    [id]: {
      ...state[id],
      stage,
    },
  }),
  [actions.CONTACTS_ASSIGN_SUCCESS]: (state, {leadId, userId}) => ({
    ...state,
    [leadId]: {
      ...state[leadId],
      assigned_to: userId,
    },
  }),
  [actions.CONTACTS_SET_NETWORK_TYPE_SUCCESS]: (state, {leadId, networkType}) => ({
    ...state,
    [leadId]: {
      ...state[leadId],
      company: {
        ...state[leadId].company,
        network_type: networkType,
      },
    },
  }),
};

const initialState = {
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
